<template>
  <div class="substep-customize-experience">
    <div class="substep-header">
      <h3 data-testId="step-title">Customize your experience</h3>
      <p>
        Choose what features work best for your team on top of our core features
      </p>
    </div>

    <div class="core-features">
      <h5>Hubstaff's core features</h5>
      <div class="pills">
        <span
          v-for="feature in coreFeatures"
          :key="feature.name"
          class="pill"
        >
          {{ feature.name }}
        </span>
      </div>
    </div>

    <div class="extra-features-card">
      <div class="card-header">
        <h5>Extra features</h5>
        <p>You can turn these settings on and off at any time in settings</p>
      </div>
      <div class="features-grid">
        <div
          v-for="feature in featureToggles"
          :key="feature.key"
          class="feature-row"
        >
          <div class="feature-main">
            <AppSwitch
              v-model="feature.enabled"
              class="feature-toggle"
              :disabled="isSaving"
            />
            <div class="feature-copy">
              <div class="feature-name">{{ feature.name }}</div>
              <div class="feature-description">{{ feature.description }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppSwitch from '~/components/AppSwitch.vue';
import { OrganizationsResource } from '~/resources';

export default {
  name: 'CustomizeYourExperience',
  components: {
    AppSwitch,
  },
  props: {
    coreFeatures: {
      type: Array,
      default: () => [],
    },
    extraFeatures: {
      type: Array,
      default: () => [],
    },
    organizationId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      featureToggles: this.extraFeatures.map((feature) => ({
        ...feature,
      })),
      isSaving: false,
    };
  },
  mounted() {
    this.$emit('completeSubstep');
  },
  created() {
    this.$parent.$on('userClickedContinue', this.handleFinishedSubstep);
  },
  beforeDestroy() {
    this.$parent.$off('userClickedContinue', this.handleFinishedSubstep);
  },
  methods: {
    baselineStates() {
      return this.extraFeatures.reduce((acc, feature) => {
        acc[feature.key] = feature.enabled;

        return acc;
      }, {});
    },
    addonsPayload() {
      const baseline = this.baselineStates();

      return this.featureToggles.reduce((acc, feature) => {
        if (feature.key && baseline[feature.key] !== feature.enabled) {
          acc[feature.key] = feature.enabled ? 1 : 0;
        }

        return acc;
      }, {});
    },
    async handleFinishedSubstep() {
      this.isSaving = true;
      const payload = this.addonsPayload();

      try {
        if (Object.keys(payload).length > 0) {
          await OrganizationsResource.updateAddons(
            { id: this.organizationId },
            { addons: payload }
          );
        }
      } catch (error) {
        this.$appMessage?.('Unable to update features right now. Please try again.');

        return;
      } finally {
        this.isSaving = false;
      }

      this.$emit('finishSubstep');
    },
  },
};
</script>
